// extracted by mini-css-extract-plugin
export default {"pagerInner":"AppPagination_pagerInner__0ekGt","pagerSelect":"AppPagination_pagerSelect__Ck9cF","pagination":"AppPagination_pagination__pcgly"};